import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import BookingCTA from "@/components/home/BookingCTA";
import BookingForm from "@/components/site/BookingForm";
import { RoomCard } from "@/components/home/RoomsGrid";
import { Reveal } from "@/components/site/Reveal";
import { ROOMS } from "@/data/rooms";
import { SITE } from "@/data/site";

export default function Stay() {
  return (
    <PageShell testId="stay-page">
      <PageHero
        overline="Rooms & Cottages"
        title={["Stay In", "The Canopy"]}
        subtitle="Distinctive stays — from glass-walled sanctuaries to a grand group cottage — each framing the valley in its own way."
        image={SITE.heroImage}
      />

      <section className="bg-ivory py-12 md:py-16">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal>
            <p className="max-w-2xl text-lg text-charcoal/70">
              Every cottage is hand-crafted in local timber and set within our coffee estate. Pick the one that fits your escape — for two, for the family, or for the whole gang.
            </p>
          </Reveal>
          <div className="mt-14 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
            {ROOMS.map((room, i) => (
              <RoomCard key={room.slug} room={room} index={i} />
            ))}
          </div>
        </div>
      </section>

      <BookingForm />
      <BookingCTA />
    </PageShell>
  );
}
